import { useState } from 'react';
import { Table, Button, Row, Col, Form, InputGroup } from 'react-bootstrap';
import { FaTrash, FaPlus, FaEdit, FaCheck, FaTimes } from 'react-icons/fa';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} from '../../slices/categoriesApiSlice';
import { toast } from 'react-toastify';

const CategoryListScreen = () => {
  const { data: categories, isLoading, error, refetch } = useGetCategoriesQuery();

  const [createCategory, { isLoading: loadingCreate }] = useCreateCategoryMutation();
  const [updateCategory, { isLoading: loadingUpdate }] = useUpdateCategoryMutation();
  const [deleteCategory, { isLoading: loadingDelete }] = useDeleteCategoryMutation();

  const [newName, setNewName] = useState('');
  const [newSortOrder, setNewSortOrder] = useState(0);
  const [editingId, setEditingId] = useState(null);
  const [editingName, setEditingName] = useState('');
  const [editingSortOrder, setEditingSortOrder] = useState(0);

  const createHandler = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    try {
      await createCategory({ name: newName.trim(), sortOrder: newSortOrder }).unwrap();
      setNewName('');
      setNewSortOrder(0);
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const startEdit = (category) => {
    setEditingId(category._id);
    setEditingName(category.name);
    setEditingSortOrder(category.sortOrder ?? 0);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditingName('');
    setEditingSortOrder(0);
  };

  const saveEdit = async (id) => {
    if (!editingName.trim()) return;
    try {
      await updateCategory({ _id: id, name: editingName.trim(), sortOrder: editingSortOrder }).unwrap();
      setEditingId(null);
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      try {
        await deleteCategory(id).unwrap();
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <>
      <Row className='align-items-center'>
        <Col>
          <h1 className='text-end'>קטגוריות</h1>
        </Col>
      </Row>

      {(loadingCreate || loadingUpdate || loadingDelete) && <Loader />}

      <Form onSubmit={createHandler} className='mb-4'>
        <InputGroup>
          <Button type='submit' variant='primary'>
            <FaPlus /> הוסף
          </Button>
          <Form.Control
            type='number'
            placeholder='סדר'
            value={newSortOrder}
            onChange={(e) => setNewSortOrder(Number(e.target.value))}
            style={{ maxWidth: '80px' }}
          />
          <Form.Control
            type='text'
            placeholder='שם קטגוריה חדשה'
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            dir='rtl'
            className='text-end'
          />
        </InputGroup>
      </Form>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error?.data?.message}</Message>
      ) : (
        <Table striped bordered hover responsive className='table-sm'>
          <thead>
            <tr>
              <th></th>
              <th>סדר</th>
              <th className='text-end'>שם קטגוריה</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((cat) => (
              <tr key={cat._id}>
                <td style={{ whiteSpace: 'nowrap', width: '1%' }}>
                  {editingId === cat._id ? (
                    <>
                      <Button
                        variant='success'
                        className='btn-sm me-1'
                        onClick={() => saveEdit(cat._id)}
                      >
                        <FaCheck />
                      </Button>
                      <Button variant='secondary' className='btn-sm' onClick={cancelEdit}>
                        <FaTimes />
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant='danger'
                        className='btn-sm me-1'
                        onClick={() => deleteHandler(cat._id)}
                      >
                        <FaTrash style={{ color: 'white' }} />
                      </Button>
                      <Button
                        variant='light'
                        className='btn-sm'
                        onClick={() => startEdit(cat)}
                      >
                        <FaEdit />
                      </Button>
                    </>
                  )}
                </td>
                <td className='text-end'>
                  {editingId === cat._id ? (
                    <Form.Control
                      type='text'
                      value={editingName}
                      onChange={(e) => setEditingName(e.target.value)}
                      dir='rtl'
                      className='text-end'
                      autoFocus
                    />
                  ) : (
                    cat.name
                  )}
                </td>
                <td style={{ width: '80px' }}>
                  {editingId === cat._id ? (
                    <Form.Control
                      type='number'
                      value={editingSortOrder}
                      onChange={(e) => setEditingSortOrder(Number(e.target.value))}
                      style={{ width: '70px' }}
                    />
                  ) : (
                    cat.sortOrder ?? 0
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default CategoryListScreen;
